import { NONE } from "@miplatform/constants";

export const ORDERS_SEARCH_FIELDS = {
  ORDER_TEMPLATE_ID: "orderTemplateId",
  ORDER_STATUS: "orderStatus",
  BUILDER_ID: "builderId",
  COMMUNITY_ID: "communityId",
};

export const ORDERS_SEARCH_GROUP_AND_SORT_BY_KEYS = {
  NONE,
  REQUESTER: "requesterId",
  ORDER_STATUS: "orderStatus",
  ORDER_TYPE: "orderTemplateId",
  BUILDER: "builderId",
  COMMUNITY: "communityId",
  APPROVED_DATE: "approvedStartDate",
  ASSIGNED_DATE: "assignedDate",
  RECEIVED_DATE: "receivedDate",
  CONFIRMATION_DATE: "confirmationDate",
};

export const ORDERS_SEARCH_GROUP_AND_SORT_BY_OPTIONS = [
  { label: NONE, value: ORDERS_SEARCH_GROUP_AND_SORT_BY_KEYS.NONE },
  {
    label: "Approved Start Date",
    value: ORDERS_SEARCH_GROUP_AND_SORT_BY_KEYS.APPROVED_DATE,
  },
  {
    label: "Assigned Date",
    value: ORDERS_SEARCH_GROUP_AND_SORT_BY_KEYS.ASSIGNED_DATE,
  },
  { label: "Builder", value: ORDERS_SEARCH_GROUP_AND_SORT_BY_KEYS.BUILDER },
  { label: "Community", value: ORDERS_SEARCH_GROUP_AND_SORT_BY_KEYS.COMMUNITY },
  {
    label: "Confirmation Date",
    value: ORDERS_SEARCH_GROUP_AND_SORT_BY_KEYS.CONFIRMATION_DATE,
  },
  {
    label: "Order Status",
    value: ORDERS_SEARCH_GROUP_AND_SORT_BY_KEYS.ORDER_STATUS,
  },
  {
    label: "Order Type",
    value: ORDERS_SEARCH_GROUP_AND_SORT_BY_KEYS.ORDER_TYPE,
  },
  {
    label: "Received Date",
    value: ORDERS_SEARCH_GROUP_AND_SORT_BY_KEYS.RECEIVED_DATE,
  },
  // TODO: Enable when requester data is available
  // { label: "Requester", value: ORDERS_SEARCH_GROUP_AND_SORT_BY_KEYS.REQUESTER },
];
